<div class="user-table">
    <p-table
        #primengTable
        currentPageReportTemplate="{{ 'CORE.TABLE_PAGINATION' | translate: { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' } }}"
        [value]="tableDataSource.tableData?.data || []"
        [tableStyle]="{ 'min-width': '50rem' }"
        [paginator]="tableConfig.paginator"
        [rows]="tableConfig.rows"
        [showCurrentPageReport]="tableConfig.showCurrentPageReport"
        [alwaysShowPaginator]="tableConfig.alwaysShowPaginator"
        [loading]="tableConfig.loading"
        [lazy]="true"
        [rowsPerPageOptions]="tableConfig.rowsPerPageOptions"
        [totalRecords]="tableDataSource.tableData?.totalRecords || 0"
        [globalFilterFields]="tableConfig.globalFilterFields"
        [(selection)]="tableConfig.selection"
        dataKey="id"
        (onLazyLoad)="tableDataSource.loadData($event)"
        (selectionChange)="tableDataSource.onSelectionChange(tableConfig.selection)"
        [selectionMode]="tableConfig.selectionMode"
    >
        <ng-template pTemplate="header">
            <ng-container *ngTemplateOutlet="headerTemplate!"></ng-container>
        </ng-template>
        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
            <ng-container *ngTemplateOutlet="bodyTemplate!; context: { $implicit: item, rowIndex: rowIndex }"></ng-container>
        </ng-template>
    </p-table>
    <div *ngIf="tableDataSource.addData" class="add-user-icon" [ngClass]="tableConfig.showSelected ? 'selected-user-mode' : ''">
        <p-button (onClick)="tableDataSource.addData()" icon="pi pi-plus" [rounded]="true"></p-button>
    </div>
</div>
<div *ngIf="tableConfig.selectionMode === 'multiple'" class="w-100 d-flex justify-content-center">
    <app-toolbar [toolbarConfig]="tableConfig.toolbarConfig" [showSelected]="tableConfig.showSelected!" [selection]="tableConfig.selection"></app-toolbar>
</div>
